import { render, staticRenderFns } from "./DfSelectField.vue?vue&type=template&id=67aa614a&scoped=true&"
import script from "./DfSelectField.vue?vue&type=script&lang=js&"
export * from "./DfSelectField.vue?vue&type=script&lang=js&"
import style0 from "./DfSelectField.vue?vue&type=style&index=0&id=67aa614a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa614a",
  null
  
)

export default component.exports